import { ScopePatternNumbersList } from "./scopePatternNumbersList";
import { ResultStatus } from "./resultStatus";

export class FindAllScopePatternNumberListResponse {
    scopePatternNumbersList?: ScopePatternNumbersList[];
    status: ResultStatus;
}